exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".boolean-component[data-v-37e8715a]{width:45px!important;margin-top:0!important;margin-left:-5px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-37e8715a&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/filter/BooleanComponent.vue
// module id = 870
// module chunks = 2